document.addEventListener("DOMContentLoaded", () => {
	
	window.consentShownCount = 0;
	window.formToSubmit = null;
window.productID = null;
	const addToCartBtn = document.getElementById("AddToCart");
	const consentPopup = document.getElementById("consent-popup");
	const acceptBtn = document.getElementById("accept-consent");
 const label = document.querySelector('.blood-test-consent-label-req');
	const label_kit = document.querySelectorAll('.blood-test-consent-label');
	const path = window.location.pathname;
	let action;
 const checkoutForm = document.querySelector('.widget_shopping_cart form[action="/cart"]');

	if (path.includes("/products/blood-test") ){
			label.style.display = 'none';
	} else if( path.includes("/cart")) {
		
		if (label) {
		    label.innerHTML = 'Please enter your details accurately- this information is required to process your order. Thank you!';
			label_kit.forEach(el => {
				el.style.display = 'none';
			});
		}
		handleConsentFlow();
	} else {
		if (label) {
			label.innerHTML = 'Please enter your details accurately- this information is required to process your order. Thank you!';
				label_kit.forEach(el => {
					el.style.display = 'none';
			});
		}
	}

	function showPopup() {
		consentPopup?.classList.add("show");
	}

	function hidePopup() {
		consentPopup?.classList.remove("show");
	}


	// if (window.customId) {
	// 	fetch(`https://consultation.dosemyhair.com/get_customer_data?id=${customId}`)
	// 		.then(res => res.json())
	// 		.then(data => {
	// 			const c = data.customer_details || {};
	// 			["birth_date", "gender", "first_name", "last_name"].forEach(key => {
	// 				const el = document.getElementById(key);
	// 				if (el && c[key]) el.value = c[key];
	// 			});
	// 		});
	// }

		if (window.location.pathname.includes("/collections/") && customId) {
			
			fetch(`https://consultation.dosemyhair.com/get_customer_data?id=${customId}`)
				.then(res => res.json())
				.then(data => {

					const c = data.customer_details || {};

					// Populate fields
					["birth_date", "gender", "first_name", "last_name", "phonenumber"].forEach(key => {
						const el = document.getElementById(key);
						if (el && c[key]) el.value = c[key];
					});

					// ✅ Consent check must be INSIDE fetch
					if (
						isOver18() &&
						c.gender?.trim() &&
						c.first_name?.trim() &&
						c.last_name?.trim() &&
						c.phonenumber?.trim()
					) {

						// localStorage.setItem('userConsent', "true");
						// document.querySelectorAll('.product-card--add-to-cart-button-simple')
						// 		.forEach(button => {
						// 			button.style.setProperty('pointer-events', 'auto');
						// 		});


					} else {
                        console.log('else');
						// Disable add-to-cart buttons

						document.querySelectorAll('.product-card--add-to-cart-button-simple')
							.forEach(button => {
								button.style.setProperty('pointer-events', 'none', 'important');
							});

						// Handle custom button clicks
						document.querySelectorAll('.btnn').forEach(btn => {
							btn.addEventListener('click', function (e) {
								const hasConsent = localStorage.getItem("userConsent");

								if (!hasConsent) {
									console.log('Here2');
									const dataId = this.id; // or btn.dataset.id
									console.log('Clicked button data-id:', dataId);
									window.productID = dataId;
									showPopup();
								}

							});
						});

						setTimeout(() => {
							// checkVariantLimit();
							document.querySelectorAll('.product-card--add-to-cart-button-simple')
								.forEach(button => {
									button.style.setProperty('pointer-events', 'none', 'important');
								});
						}, 800);

						setTimeout(() => {
							document.querySelectorAll('.product-card--add-to-cart-button-simple')
								.forEach(button => {
									button.style.setProperty('pointer-events', 'none', 'important');
								});
						}, 1100);
						
						setTimeout(() => {
							document.querySelectorAll('.product-card--add-to-cart-button-simple')
								.forEach(button => {
									button.style.setProperty('pointer-events', 'none', 'important');
								});
						}, 1500);
					}
				});
		}

		addToCartBtn?.addEventListener("click", (e) => {
			
			const activeOption = document.querySelector('.appstle-active-option');
			const tcCheckbox = document.getElementById('terms_conditions');

			if (
			activeOption &&
			activeOption.querySelector('#appstle_selling_plan_label_20') &&
			tcCheckbox && !tcCheckbox.checked
			) { 
				e.preventDefault();
				alert("Please approve subscription commitment");
				return;
			}

			checkPopup(e, 'addtocart');
			setTimeout(checkVariantLimit, 800);
		});

		acceptBtn?.addEventListener("click", () => {
				const firstName = document.getElementById("first_name")?.value.trim();
				const lastName = document.getElementById("last_name")?.value.trim();
				const gender = document.getElementById("gender")?.value;
				const dob = document.getElementById("birth_date")?.value;
				const phonenumber = document.getElementById("phonenumber")?.value;
				const checkbox = document.getElementById("consentCheckbox");

				if (!firstName || !/^[A-Za-z]+$/.test(firstName)) {
					alert("Invalid first name");
					return;
				}

				if (!lastName || !/^[A-Za-z]+$/.test(lastName)) {
					alert("Invalid last name");
					return;
				}

				if (!gender || !isOver18()) {
					alert("Age must be 18+ and gender selected");
					return;
				}
				
				if (path.includes("/products/blood-test") && !checkbox?.checked) {
					alert("Please approve consent");
					return;
				}

				if (!phonenumber) {
					alert("Invalid Phone Number");
					return;
				}

				// localStorage.setItem("userConsent", "true");
				// hidePopup();

				fetch("https://consultation.dosemyhair.com/post_customer_data", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({
							id: customId,
							gender,
							dob,
							first_name: firstName,
							last_name: lastName,
							phonenumber: phonenumber
					})
				}).then((response) => {
					console.log("Response:", response);
					return response.json();
				})
				.then((data) => {
					// console.log("data-- ", data)
					if(data.status == "error"){
						if(data.errors.phonenumber){
							alert(data.errors.phonenumber);
						}
						if(data.errors.phone){
							alert(data.errors.phone);
						}
						return;
					}
                    
					localStorage.setItem("userConsent", "true");
				    hidePopup();

					if (path.includes("/products")){
							addToCartBtn.disabled = false;
							addToCartBtn.click();
					}

					if (path.includes("/collections")){
						//window.location.reload(true);
							const pID = window.productID;
							var selectedProduct = document.getElementById(pID);
							const anchor = selectedProduct.querySelector('a');
							if (anchor) {
								anchor.style.setProperty('pointer-events', 'auto', 'important');
							}
					}
				});
		});

 		if (!checkoutForm) return;

		checkoutForm.addEventListener(
			"submit",
			function (e) {
				console.log('Checkout Logged : : ', e);
					// 🚫 ALWAYS block native submit first
					e.preventDefault();
					e.stopImmediatePropagation();

					const hasConsent = localStorage.getItem("userConsent");
					console.log('Consent  Logged : : ', hasConsent);
					if (!hasConsent) {
						showPopup(); // ❗ Show consent popup
						return false;
					}
					// ✅ Consent exists → submit safely
					checkoutForm.removeEventListener("submit", arguments.callee);
					checkoutForm.submit();
			},
			true // 👈 CAPTURE PHASE (important for Shopify)
		);

		function handleConsentFlow(e = null) {

			// Consent already given
			// Show consent popup only once
			const consentValue = localStorage.getItem("userConsent");
			if (window.consentShownCount === 0 	&& !consentValue) {
							// if (e) e.preventDefault();
							document.getElementById("consent-popup")?.classList.add("show");
							window.consentShownCount++;
							return false;
			}

			if (customId) {
				fetch(`https://consultation.dosemyhair.com/get_customer_data?id=${customId}`)
					.then(res => res.json())
					.then(data => {
						const c = data.customer_details || {};
						["birth_date", "gender", "first_name", "last_name","phonenumber"].forEach(key => {
							const el = document.getElementById(key);
							if (el && c[key]) el.value = c[key];
						});

						console.log('Customer Data : : ',c);
						if(!isOver18() || !c.gender?.trim()  || !c.first_name?.trim() || !c.last_name?.trim() || !c.phonenumber?.trim() ){
								showPopup();

						}
					});
			}
			return true;
		}

		function checkPopup(e, action){
			if (!customId) {
				e.preventDefault();
				window.location.href =
						"/account/login?redirect_uri=/products/blood-test-kit";
				return;
			}

			if (localStorage.getItem("userConsent") === "true" &&	document.getElementById("consentCheckbox")?.checked	) {
				localStorage.removeItem("userConsent");
				return;
			}

			if (consentShownCount === 0 && !addToCartBtn.classList.contains("sold-out")	) {
				e.preventDefault();
				formToSubmit = addToCartBtn.closest("form");
				showPopup();
				consentShownCount++;
			}
		}
});